import React, { lazy } from 'react';
import { Field } from 'formik';
import i18n from 'i18next';
import { FormikDatePicker } from 'globalcomponents/UI/Form/Base';
import { UI_DATE_LOWER_FORMAT } from 'globalconfig/constants/static';
import { getDateLocale } from 'globalutils/fmUtils';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { CustomSwitch } from '../CustomSwitch/CustomSwitch';

const layout = window.$environment?.CURRENT_LAYOUT;
const Label = lazy(() => import(`globalcomponents/UI/FormLabel/${layout}`));
const FormStyle = require(`globalcomponents/UI/Form/${layout}/serverStyle`).default;

export default function AutoPayment({ values, handleEdit, showError, errors, isNotValid, hasSaveApiStatus }) {
  return (
    <>
      <FormStyle.FieldsWrapper>
        <Label htmlFor="autoPaymentEnabled" variant="body1">
          {i18n.t('companyData.monthlyAutoPay')}
        </Label>
        <Typography component="div">
          <Grid component="label" container alignItems="center" spacing={1}>
            <Grid item>Off</Grid>
            <Grid item>
              <CustomSwitch
                size="normal"
                checked={values.autoPaymentEnabled}
                onChange={(event) => {
                  handleEdit(event.target.checked, {
                    field: 'autoPaymentEnabled',
                  });
                  handleEdit('', {
                    field: 'freeTrialEndDate',
                  });
                }}
                name="checkedC"
              />
            </Grid>
            <Grid item>On</Grid>
          </Grid>
        </Typography>
      </FormStyle.FieldsWrapper>
      {!values.autoPaymentEnabled && (
        <FormStyle.FieldsWrapper width="100%">
          <Label variant="body1" htmlFor="freeTrialEndDate">
            {i18n.t('companyData.freeTrialEndsOn')}
          </Label>
          <FormStyle.TextWrapper className="userForm">
            <Field
              name="freeTrialEndDate"
              onChange={(event) => {
                handleEdit(event, {
                  field: 'freeTrialEndDate',
                  type: 'date',
                });
              }}
              locale={getDateLocale()}
              as={FormikDatePicker}
              placeholderText={UI_DATE_LOWER_FORMAT}
              value={values['freeTrialEndDate']}
              type="date"
              showPopperArrow={false}
              showTimeSelect={false}
              showDisabledMonthNavigation
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              isClearable={true}
              minDate={new Date()}
            />
            {showError('freeTrialEndDate', errors, isNotValid, hasSaveApiStatus?.errorMessage)}
          </FormStyle.TextWrapper>
        </FormStyle.FieldsWrapper>
      )}
    </>
  );
}
